import { BiAxisSide, BiSeriesType, BiVizType } from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
} from '../functions/biGalleryTypes';
import {
  cents,
  kGalleryFields as f,
  galleryReady,
  galleryResult,
  kGalleryMonths,
} from './biGalleryFields';

const revenue = [
  182400, 168900, 205300, 221800, 238600, 226100, 251400, 263900, 248700,
  272300,
];
const orders = [468, 431, 512, 547, 583, 562, 611, 638, 597, 652];
const target = [
  190000, 180000, 200000, 215000, 230000, 235000, 245000, 255000, 260000,
  270000,
];
const returnRate = [
  0.412, 0.398, 0.425, 0.433, 0.451, 0.447, 0.462, 0.471, 0.458, 0.483,
];

const result = galleryResult(
  [f.month, f.revenue, f.orders, f.avgTicket, f.target, f.returnRate],
  kGalleryMonths.map((month, i) => [
    month,
    cents(revenue[i]),
    orders[i],
    cents(revenue[i] / orders[i]),
    cents(target[i]),
    returnRate[i],
  ]),
);

const barLine: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '月度营收与工单数',
  viz: {
    type: BiVizType.Bar,
    x: f.month.key,
    series: [
      { key: f.revenue.key },
      { key: f.orders.key, as: BiSeriesType.Line, axis: BiAxisSide.Right },
    ],
  },
  data: galleryReady(result),
};

export const kComboCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.Combo,
  name: '组合图',
  description: '柱 + 线、柱 + 面积、右轴、实际 vs 目标',
  preview: barLine,
  variants: [
    {
      key: 'bar-line',
      name: '柱 + 线',
      note: '工单数 as = line，axis = right',
      card: barLine,
    },
    {
      key: 'bar-area',
      name: '柱 + 面积',
      note: '客单价 as = area，axis = right',
      card: {
        surface: 'dashboard',
        title: '月度营收与客单价',
        viz: {
          type: BiVizType.Bar,
          x: f.month.key,
          series: [
            { key: f.revenue.key },
            {
              key: f.avgTicket.key,
              as: BiSeriesType.Area,
              axis: BiAxisSide.Right,
            },
          ],
        },
        data: galleryReady(result),
      },
    },
    {
      key: 'right-axis',
      name: '右轴（不同单位）',
      note: '工单数在左轴，复购率在右轴，带轴标题',
      card: {
        surface: 'dashboard',
        title: '工单数与复购率',
        viz: {
          type: BiVizType.Line,
          x: f.month.key,
          series: [
            { key: f.orders.key },
            { key: f.returnRate.key, axis: BiAxisSide.Right },
          ],
          style: {
            axes: {
              y: { show: true, label: '工单数' },
              y2: { show: true, label: '复购率' },
            },
          },
        },
        data: galleryReady(result),
      },
    },
    {
      key: 'actual-target',
      name: '实际 vs 目标',
      note: '实际为柱，目标为同轴折线',
      card: {
        surface: 'dashboard',
        title: '月度营收完成情况',
        viz: {
          type: BiVizType.Bar,
          x: f.month.key,
          series: [
            { key: f.revenue.key, name: '实际营收' },
            { key: f.target.key, as: BiSeriesType.Line },
          ],
          style: {
            line: { width: 2, smooth: false, showPoints: false },
          },
        },
        data: galleryReady(result),
      },
    },
    {
      key: 'labels',
      name: '组合 · 数据标签',
      note: 'dataLabels = true',
      card: {
        ...barLine,
        viz: { ...barLine.viz, style: { dataLabels: true } },
      },
    },
  ],
};
